import { ProductAvailability } from 'src/app/core/domain/variant-group.model';

export const AVAILABILITY_STATUSES = {
  available_with_high_qty: ProductAvailability.available_with_high_qty,
  not_available: ProductAvailability.not_available,
  available_for_preorder: ProductAvailability.available_for_preorder,
  available_with_low_qty: ProductAvailability.available_with_low_qty,
  available: ProductAvailability.available,
};
